module.exports = __webpack_public_path__ + "static/media/pr.a212b3f1.svg";